import * as i0 from '@angular/core';
import { Directive, Input, HostBinding, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

class LinkDirective {
    constructor() {
        this.variant = 'primary';
    }
    get classes() {
        return {
            link: true,
            // variant
            'link--primary': this.variant === 'primary',
            'link--read-more': this.variant === 'readmore',
            'link--read-less': this.variant === 'readless',
            // modifiers
            'link--external': this.external,
            'link--inline': this.inline,
            'link--left-arrow': this.leftArrow && this.variant !== 'secondary',
            'link--no-arrow': this.noArrow && this.variant !== 'secondary',
            'is-disabled': this.disabled,
        };
    }
}
LinkDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: LinkDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
LinkDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.2", type: LinkDirective, selector: "[sdLink], sd-link", inputs: { variant: "variant", size: "size", external: "external", inline: "inline", leftArrow: "leftArrow", noArrow: "noArrow", disabled: "disabled" }, host: { properties: { "class": "this.classes" } }, exportAs: ["sdLink"], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: LinkDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[sdLink], sd-link',
                    exportAs: 'sdLink',
                }]
        }], propDecorators: { variant: [{
                type: Input
            }], size: [{
                type: Input
            }], external: [{
                type: Input
            }], inline: [{
                type: Input
            }], leftArrow: [{
                type: Input
            }], noArrow: [{
                type: Input
            }], disabled: [{
                type: Input
            }], classes: [{
                type: HostBinding,
                args: ['class']
            }] } });

class SmartDesignLinkModule {
}
SmartDesignLinkModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: SmartDesignLinkModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SmartDesignLinkModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: SmartDesignLinkModule, declarations: [LinkDirective], imports: [CommonModule], exports: [LinkDirective] });
SmartDesignLinkModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: SmartDesignLinkModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: SmartDesignLinkModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [LinkDirective],
                    imports: [CommonModule],
                    exports: [LinkDirective],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { LinkDirective, SmartDesignLinkModule };
